import React, { MutableRefObject } from "react";
import { useSelector } from "store/hooks";
import { AxisBottom } from "./AxisBottom";
import { AxisLeft } from "./AxisLeft";
import { PastBackground } from "./PastBackground";
import { BookingSegments } from "./segments/BookingSegments";
import { LicensePlateSegments } from "./segments/LicensePlateSegments";
import { OneTimePremiumSegments } from "./segments/OneTimePremiumSegments";
import { PolicyStatusSegments } from "./segments/PolicyStatusSegments";
import { PremiumSegments } from "./segments/PremiumSegments";
import { SharedLicensePlateSegments } from "./segments/SharedLicensePlateSegments";
import { StatusSegments } from "./segments/StatusSegments";

interface IProps {
  x: number;
  y: number;
  timezoneWidth: number;
  timezoneHeight: number;
  xScale: any;
  yScale: any;
  showBookings: boolean;
  expandablePointRefs: MutableRefObject<{}>;
  expandedPointSectionRefs: MutableRefObject<{}>;
}

export const MainTimeline = ({
  x,
  y,
  timezoneWidth,
  xScale,
  yScale,
  timezoneHeight,
  showBookings,
  expandablePointRefs,
  expandedPointSectionRefs,
}: IProps) => {
  const appSettings = useSelector((s) => s.timeline.timelineAppSettings);

  return (
    <g transform={`translate(${x},${y})`}>
      <PastBackground
        innerHeight={timezoneHeight}
        innerWidth={timezoneWidth}
        xScale={xScale}
      />
      <AxisBottom innerHeight={timezoneHeight} xScale={xScale} />
      <PremiumSegments
        xScale={xScale}
        yScale={yScale}
        innerWidth={timezoneWidth}
      />
      <PolicyStatusSegments
        xScale={xScale}
        yScale={yScale}
        innerWidth={timezoneWidth}
        expandablePointRefs={expandablePointRefs}
        expandedPointSectionRefs={expandedPointSectionRefs}
      />
      <OneTimePremiumSegments
        xScale={xScale}
        yScale={yScale}
        innerWidth={timezoneWidth}
      />
      <BookingSegments
        xScale={xScale}
        yScale={yScale}
        innerWidth={timezoneWidth}
        showBookings={showBookings}
      />

      <StatusSegments
        xScale={xScale}
        yScale={yScale}
        innerWidth={timezoneWidth}
      />
      <LicensePlateSegments
        xScale={xScale}
        yScale={yScale}
        innerWidth={timezoneWidth}
      />
      <SharedLicensePlateSegments
        xScale={xScale}
        yScale={yScale}
        innerWidth={timezoneWidth}
      />
      <AxisLeft yScale={yScale} />
    </g>
  );
};
